






























import { Vue, Component, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

import {
	FormattedOrdwayCharge,
	OrdwayCharge,
	OrdwayChargeTier,
	OrdwayPlan,
	ProductOrdwayAttributes,
} from '@/models/ordway';
import { OrdwayService } from '@/services/ordway-service';
import { Product, Vat } from '@/api';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: { SaveCancelButtons },
})
export default class EditPlanChargesModal extends Vue {
	// Not sure about having editable data in a computed property here....
	get planCharges(): OrdwayCharge[] | [] {
		if (this.ordwayPlan !== null) {
			return this.ordwayPlan.charges;
		}
		return [];
	}

	get nVats(): number {
		if (this.product !== null) {
			return this.product.vats.length;
		}
		return 0;
	}

	public submitting: boolean = false;
	public ordwayPlanCharges: FormattedOrdwayCharge[] = [];

	@Prop()
	private product!: Product & { vats: Vat[] };
	private ordwayAttributes: ProductOrdwayAttributes | null = null;
	private ordwayPlan: OrdwayPlan | null = null;

	public created() {
		OrdwayService.fetchProductOrdwayAttributes(this.product.id!, this.product.orgId!).then(
			async (attributes: AxiosResponse<ProductOrdwayAttributes>) => {
				this.ordwayAttributes = attributes.data;
				await this.loadPlanDetails(this.ordwayAttributes.ordwayPlanId);
			},
		);
	}

	public onSubmit(): void {
		this.submitting = true;
		this.$emit('charges-confirmed', this.ordwayPlan);
		this.$on('hide', () => {
			this.submitting = false;
		});
	}

	public dismissModal(): void {
		this.$bvModal.hide('edit-charges-modal');
	}

	public chargePrice(charge: OrdwayCharge): string {
		if (charge.list_price !== '') {
			if (charge.type === 'Usage based') {
				return charge.list_price + ' per unit';
			}
			return charge.list_price;
		}
		if (charge.pricing_model === 'Tiered') {
			if (charge.name === 'Annual Additional Vat Charge' || charge.name === 'One-off Install Fee') {
				const tier = charge.tiers.find((ordwayChargetier: OrdwayChargeTier) => {
					return (
						this.product.vats.length >= parseInt(ordwayChargetier.starting_unit, 10) &&
						(this.product.vats.length <= parseInt(ordwayChargetier.ending_unit, 10) ||
							ordwayChargetier.ending_unit === '')
					);
				});
				if (tier !== undefined) {
					return tier.price;
				}
			}
		}
		return '';
	}

	private async loadPlanDetails(ordwayPlanId: string): Promise<void> {
		this.ordwayPlan = await OrdwayService.fetchSingleOrdwayPlan(ordwayPlanId);
		this.ordwayPlanCharges = await OrdwayService.fetchFormattedChargePrices(
			this.product.id!,
			ordwayPlanId,
		);
	}
}
